/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePriceListRequest } from '../models/CreatePriceListRequest';
import type { PageablePriceListResponse } from '../models/PageablePriceListResponse';
import type { PriceListResponse } from '../models/PriceListResponse';
import type { UpdatePriceListRequest } from '../models/UpdatePriceListRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PriceListApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create price list
   * @param requestBody Request
   * @returns any Create price list
   * @throws ApiError
   */
  public createPriceList(
    requestBody?: CreatePriceListRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/price-lists',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get price list
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageablePriceListResponse Get price list
   * @throws ApiError
   */
  public getPriceList(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageablePriceListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/price-lists',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get price list by id
   * @param id
   * @returns PriceListResponse Get project response
   * @throws ApiError
   */
  public getPriceListById(
    id: string,
  ): CancelablePromise<PriceListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/price-lists/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Update price list
   * @param id
   * @param requestBody
   * @returns any Updated
   * @throws ApiError
   */
  public updatePriceList(
    id: string,
    requestBody?: UpdatePriceListRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/price-lists/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get by name
   * @param name
   * @returns PriceListResponse Get price list response
   * @throws ApiError
   */
  public getPriceListByName(
    name: string,
  ): CancelablePromise<PriceListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/price-lists/name/{name}',
      path: {
        'name': name,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
